// extracted by mini-css-extract-plugin
export default {"downloads":"LessonPage-module--downloads--427e8"};